import { toTitleCase } from '@/utils/commonUtils';

export const formatSponsorLocation = (sponsor) => {
    return [sponsor?.city_name, sponsor?.state_name, sponsor?.country_name]
        .filter(Boolean)
        .map((item) => toTitleCase(item))
        .join(', ');
};
